<template>
  <div class="recommendations-list">
    <h3 class="recommendations-list__title">
      {{ $t('purchaseV2.basket.potentialOptions') }}
    </h3>
    <div v-if="areRecommendationsLoading" class="recommendations-list__message">
      Loading...
    </div>
    <div v-else-if="!areThereCartItems" class="recommendations-list__message">
      {{ $t('purchaseV2.basket.selectItemsForRecommendations') }}
    </div>
    <div
      v-else-if="!recommendations.length"
      class="recommendations-list__message">
      {{ $t('purchaseV2.basket.noItemsToRecommend') }}
    </div>
    <div v-else class="recommendations-list__content">
      <RecommendationCard
        v-for="(recommendation, index) in recommendations"
        :key="index"
        :recommendation="recommendation"
        :arena-currency="arenaCurrency"
        class="recommendations-list__card"
        @hover-enter="onRecommendationHover"
        @hover-leave="onRecommendationLeave"
        @click="onRecommendationClick" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CartsApi from '@/services/shop/CartsApiV2'
import RecommendationCard from './RecommendationCard.vue'

export default {
  name: 'RecommendationsList',
  components: {
    RecommendationCard,
  },
  props: {
    arenaCurrency: { type: Object, default: () => ({}) },
  },
  data: () => ({
    recommendations: [],
    areRecommendationsLoading: false,
    hoveredRecommendation: null,
  }),
  computed: {
    ...mapGetters('cart', ['cartId', 'cartItems']),
    arenaId() {
      return this.$store.getters.arena?.id
    },
    areThereCartItems() {
      return this.cartId && this.cartItems.length > 0
    },
    highlightedCartItemIds() {
      if (!this.hoveredRecommendation) return new Set()
      const ids = new Set()
      if (this.hoveredRecommendation?.existing_items) {
        this.hoveredRecommendation.existing_items.forEach((item) => {
          if (item?.cart_item_id) {
            ids.add(item.cart_item_id)
          }
        })
      }
      return ids
    },
  },
  watch: {
    highlightedCartItemIds: {
      handler(newIds) {
        this.$emit('highlighted-ids-changed', Array.from(newIds))
      },
      immediate: true,
    },
  },
  methods: {
    async fetchPromotions() {
      if (!this.arenaId || !this.cartId) {
        this.recommendations = []
        return
      }
      this.areRecommendationsLoading = true
      try {
        const response = await CartsApi.getRecommendations(
          this.arenaId,
          this.cartId,
        )
        this.recommendations = response.data || []
      } catch (error) {
        console.error(error)
        this.recommendations = []
      } finally {
        this.areRecommendationsLoading = false
      }
    },
    onRecommendationHover(recommendation) {
      this.hoveredRecommendation = recommendation
    },
    onRecommendationLeave() {
      this.hoveredRecommendation = null
    },
    onRecommendationClick(recommendation) {
      this.$emit('recommendation-click', recommendation)
    },
  },
}
</script>

<style scoped>
.recommendations-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  padding-top: 1.5rem;
}

.recommendations-list__title {
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #2b2b2b;
}

.recommendations-list__message {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
  color: #6d6d6d;
  font-size: 0.875rem;
}

.recommendations-list__content {
  flex: 1 1 0;
  overflow-y: auto;
  padding-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-height: 0;
}

.recommendations-list__card {
  width: 100%;
}
</style>
